module.exports = __webpack_public_path__ + "static/media/LegoFloatingHQEXTDeckA0071_design_clean_v001.dc2b1dcd.png";